(function () {
  'use strict';

  angular.module('ringbaPortal').component('targetGroupForm', {
    bindings: {
      currentTargetGroup: '<',
      addRouteEnabled: '<',
      isModal: '<',
      addRoute: '&',
      onSave: '&',
      onDismiss: '&',
      isRpc: '<',
    },
    controller: TargetGroupFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/target-group-form.view.html'
  });

  function TargetGroupFormController(
    _,
    $filter,
    $scope,
    $uibModal,
    $q,
    $timeout,
    accountsService,
    infoService,
    targetService,
    pingTreeTargetService,
    targetGroupService,
    capSettingsService,
    toaster,
    utils,
    featureFlags,
  ) {

    'ngInject';

    const vm = this;

    vm.currentCallRoute = {};
    vm.callCaps = {};
    vm.showAdvancedHours = false;
    vm.setHours = false;
    vm.isRefreshingTargets = false;
    vm.isRefreshingRingTreeTargets = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.addTargetToGroup = addTargetToGroup;
    vm.addRingTreeTargetToGroup = addRingTreeTargetToGroup;
    vm.deleteTargetFromGroup = deleteTargetFromGroup;
    vm.deleteRingTreeTargetFromGroup = deleteRingTreeTargetFromGroup;
    vm.isOverrideActive = isOverrideActive;
    vm.save = save;
    vm.onScheduleChange = onScheduleChange;
    vm.onOverideChange = onOverideChange;
    vm.resetCapCounters = resetCapCounters;
    vm.confirmResetCapCounters = confirmResetCapCounters;
    vm.cancelModal = cancelModal;
    vm.matrixUpdated = matrixUpdated;
    vm.isTargetFree = isTargetFree;
    vm.selectTargetInGroup = selectTargetInGroup;
    vm.selectRingTreeTargetInGroup = selectRingTreeTargetInGroup;
    vm.onRefreshTargets = onRefreshTargets;
    vm.onRefreshRingTreeTargets = onRefreshRingTreeTargets;
    vm.toggleSetHours = toggleSetHours;

    vm.targetInGroup = null;
    vm.ringTreeTargetInGroup = null;

    vm.onWeekDayMatrixUpdated = onWeekDayMatrixUpdated;

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      _loadAllTargets();
      _loadTimeZones();
      toggleSetHours();
    }

    function onChanges(changesObj) {
      if (changesObj.currentTargetGroup && typeof vm.currentTargetGroup !== 'undefined') {

        if (vm.currentTargetGroup.targets) {
          vm.targetGroupTargets = angular.copy(vm.currentTargetGroup.targets);
        } else {
          vm.targetGroupTargets = [];
        }

        if (vm.currentTargetGroup.ringTreeTargets) {
          vm.targetGroupRingTreeTargets = angular.copy(vm.currentTargetGroup.ringTreeTargets);
        } else {
          vm.targetGroupRingTreeTargets = [];
        }

        if (vm.currentTargetGroup.schedule) {
          _initializeCallCaps();
          if (vm.currentTargetGroup.schedule.callConcurrencyMatrix && vm.currentTargetGroup.schedule.callConcurrencyMatrix.length > 0) {
            vm.setConcurrency = true;
            vm.showAdvancedConcurrency = true;
          }
        }
      }
    }

    function onOverideChange(type, campaign, global) {
      if (type === 'oSchedule') {
        vm.currentTargetGroup.oSchedule = vm.currentTargetGroup.oSchedule || {};
        vm.currentTargetGroup.oSchedule.campaignOverride = campaign;
        vm.currentTargetGroup.oSchedule.globalOverride = global;
      }

      if (type === 'oCapacity') {
        vm.currentTargetGroup.oCapacity = vm.currentTargetGroup.oCapacity || {};
        vm.currentTargetGroup.oCapacity.campaignOverride = campaign;
        vm.currentTargetGroup.oCapacity.globalOverride = global;
      }

      if (type === 'oConcurrency') {
        vm.currentTargetGroup.oConcurrency = vm.currentTargetGroup.oConcurrency || {};
        vm.currentTargetGroup.oConcurrency.campaignOverride = campaign;
        vm.currentTargetGroup.oConcurrency.globalOverride = global;
      }
    }

    function addTargetToGroup() {
      if (!vm.currentTargetGroup.targets) {
        vm.currentTargetGroup.targets = [];
      }
      vm.currentTargetGroup.targets.push(vm.targetInGroup);
      vm.targetInGroup = null;
      vm.selectedTarget = null;
    }

    function selectTargetInGroup(target) {
      vm.targetInGroup = target;
    }
    function selectRingTreeTargetInGroup(target) {
      vm.ringTreeTargetInGroup = target;
    }

    function addRingTreeTargetToGroup() {
      if (!vm.currentTargetGroup.ringTreeTargets) {
        vm.currentTargetGroup.ringTreeTargets = [];
      }
      vm.currentTargetGroup.ringTreeTargets.push(vm.ringTreeTargetInGroup);
      vm.ringTreeTargetInGroup = null;
      vm.selectedRingTreeTarget = null;
    }

    function isTargetFree(target) {
      return !(target.targetGroupId && target.targetGroupId !== vm.currentTargetGroup.id);
    }

    function deleteTargetFromGroup(targetId) {
      vm.currentTargetGroup.targets.splice(_.findIndex(vm.currentTargetGroup.targets, { 'id': targetId }), 1);
    }

    function deleteRingTreeTargetFromGroup(targetId) {
      vm.currentTargetGroup.ringTreeTargets.splice(_.findIndex(vm.currentTargetGroup.ringTreeTargets, { 'id': targetId }), 1);
    }


    // TODO: Bump this up to select-target
    async function save() {
      await _createUpdateTargetGroup();
    }

    function onScheduleChange(hoursOfOperation) {
      vm.currentTargetGroup.schedule = vm.currentTargetGroup.schedule || {};
      vm.currentTargetGroup.schedule.hoursOfOperation = hoursOfOperation;
    }

    function isOverrideActive(or) {
      return or && (or.campaignOverride || or.globalOverride);
    }

    async function resetCapCounters() {
      try {
        await targetGroupService.resetCallCounters(accountsService.currentAccountId, vm.currentTargetGroup.id);
        toaster.pop('success', $filter('translate')('RESET_COUNTERS_SUCCESS'));
        vm.cancelModal();
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    function confirmResetCapCounters() {
      vm.modalBodyText = $filter('translate')('RESET_COUNTERS_MODAL_BODY', { target: 'Target Group' });
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/reset-target-group-counters.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    // TODO: Push this up to select-target component
    async function _createUpdateTargetGroup() {
      if (isOverrideActive(vm.currentTargetGroup.oSchedule)) {
        _resetHours();
      }
      if (isOverrideActive(vm.currentTargetGroup.oCapacity)) {
        _resetCallCaps();
      }
      if (isOverrideActive(vm.currentTargetGroup.oConcurrency)) {
        _resetConcurrencyCap();
      }



      const newTargets = $filter('notInArray')(vm.currentTargetGroup.targets, vm.targetGroupTargets, 'id');
      const removedTargets = $filter('notInArray')(vm.targetGroupTargets, vm.currentTargetGroup.targets, 'id');
      const newRingTreeTargets = $filter('notInArray')(vm.currentTargetGroup.ringTreeTargets, vm.targetGroupRingTreeTargets, 'id');
      const removedRingTreeTargets = $filter('notInArray')(vm.targetGroupRingTreeTargets, vm.currentTargetGroup.ringTreeTargets, 'id');

      const updateTargetsRequest = {
        targetAddIds: newTargets?.map(t => t.id),
        targetRemoveIds: removedTargets?.map(t => t.id),
        ringTreeTargetAddIds: newRingTreeTargets?.map(t => t.id),
        ringTreeTargetRemoveIds: removedRingTreeTargets?.map(t => t.id),
      };
      try {
        if (vm.currentTargetGroup.id) {
          _updateCallCapsInTargetGroup(vm.callCaps, vm.currentTargetGroup.schedule);

          const updatedTargetGroup = await targetGroupService.updateTargetGroup(accountsService.currentAccountId, vm.currentTargetGroup);
          if (vm.currentCallRoute && vm.addRouteEnabled) {
            await _addRoute(vm.currentTargetGroup);
          }
          await _updateTargets(vm.currentTargetGroup.id, updateTargetsRequest);
          toaster.pop('success', $filter('translate')('TARGET_GROUP_UPDATE_SUCCESS'));
          vm.onSave({
            $event: {
              newTargetGroup: false,
              targetGroup: updatedTargetGroup
            }
          });
        } else {
          const createdTargetGroup = await targetGroupService.createTargetGroup(accountsService.currentAccountId, vm.currentTargetGroup);
          await _updateTargets(createdTargetGroup.id, updateTargetsRequest);
          if (vm.currentCallRoute && vm.addRoute) {
            await _addRoute(createdTargetGroup);
          }
          toaster.pop('success', $filter('translate')('TARGET_GROUP_CREATE_SUCCESS'));
          vm.onSave({
            $event: {
              newTargetGroup: true,
              targetGroup: createdTargetGroup
            }
          });
        }
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    function _addRoute(targetGroup) {
      vm.currentCallRoute.targetGroupId = targetGroup.id;
      vm.currentCallRoute.callTargetGroup = targetGroup;
      return vm.addRoute({ route: vm.currentCallRoute });
    }

    function _updateTargets(targetGroupId, updateRequest) {
      return targetGroupService.updateTargets(accountsService.currentAccountId, targetGroupId, updateRequest);
    }

    async function _loadAllTargets() {
      try {
        vm.currentTargets = await targetService.getTargets(accountsService.currentAccountId);
        if (featureFlags.isOn('rtt_in_group')) {
          vm.currentRingTreeTargets = await pingTreeTargetService.getTargets(accountsService.currentAccountId);
        }
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    async function _loadTargets() {
      try {
        vm.currentTargets = await targetService.getTargets(accountsService.currentAccountId);
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    async function _loadRingTreeTargets() {
      try {
        vm.currentRingTreeTargets = await pingTreeTargetService.getTargets(accountsService.currentAccountId);
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    // TODO: Push this up to the select-target component
    async function _loadTimeZones() {
      try {
        const timezoneData = await infoService.getTimeZones();
        vm.timeZones = timezoneData.data;
      }
      catch (e) {
        utils.errorHandler(e);
      }
    }

    // Set values for call cap toggles
    function _initializeCallCaps() {
      capSettingsService.sanitizeCapPerDayOfWeekFromSingleValue(vm.currentTargetGroup.schedule, 'dailyCap', 'dailyCapDayOfWeek');

      if (vm.currentTargetGroup.schedule.allTimeCap >= 0) { vm.callCaps.allTimeCap = 1; } else { delete vm.currentTargetGroup.schedule.allTimeCap; }
      if (vm.currentTargetGroup.schedule.monthlyCap >= 0) { vm.callCaps.monthlyCap = 1; } else { delete vm.currentTargetGroup.schedule.monthlyCap; }

      if (vm.currentTargetGroup.schedule.dailyCap >= 0) { vm.callCaps.dailyCap = 1; } else { delete vm.currentTargetGroup.schedule.dailyCap; }
      if (vm.currentTargetGroup.schedule.dailyCapDayOfWeek != undefined && vm.currentTargetGroup.schedule.dailyCapDayOfWeek.length > 0) {
        vm.callCaps.dailyCap = 1;
      }

      vm.currentTargetGroup.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToDisplay(vm.currentTargetGroup.schedule.dailyCapDayOfWeek);


      if (vm.currentTargetGroup.schedule.callCapMatrix != null) {
        //set -1 to nulls
        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            if (vm.currentTargetGroup.schedule.callCapMatrix[day][hour] == -1) {
              vm.currentTargetGroup.schedule.callCapMatrix[day][hour] = null;
            }
          }
        }

        const allSame = _isBasicHourlyCap(vm.currentTargetGroup.schedule.callCapMatrix);
        if (allSame && vm.currentTargetGroup.schedule.callCapMatrix[0][0] == null) {
          vm.currentTargetGroup.schedule.callCapMatrix = null;
        }
      }

      if (vm.currentTargetGroup.schedule.hourlyCap >= 0 || vm.currentTargetGroup.schedule.callCapMatrix != null) {
        vm.callCaps.hourlyCap = 1;
        if (vm.currentTargetGroup.schedule.callCapMatrix == null) {
          //build matrix with full data.
          vm.currentTargetGroup.schedule.callCapMatrix = targetService.createMatrix(vm.currentTargetGroup.schedule.hourlyCap);
          //start discarding this property to only use the matrix
          vm.currentTargetGroup.schedule.hourlyCap = -1;
        }
      } else {
        delete vm.currentTargetGroup.schedule.hourlyCap;
        delete vm.currentTargetGroup.schedule.callCapMatrix;
      }

      if (vm.currentTargetGroup.schedule.concurrencyCap >= 0) { vm.callCaps.concurrencyCap = 1; } else { delete vm.currentTargetGroup.schedule.concurrencyCap; }
      if (vm.currentTargetGroup.schedule.callConcurrencyMatrix) {
        vm.disableConcurrencyCap = true;
      }
    }

    function _isBasicHourlyCap(matrix) {
      const compareHour = matrix[0][0];
      return _.every(matrix, function (day) {
        return _.every(day, function (hour) {
          return _.isEqual(hour, compareHour);
        });
      });
    }

    // Reset values of call caps based on toggle position
    function _resetCallCaps() {
      if (vm.callCaps.allTimeCap === -1) { vm.currentTargetGroup.schedule.allTimeCap = -1; }
      if (vm.callCaps.monthlyCap === -1) { vm.currentTargetGroup.schedule.monthlyCap = -1; }
      if (vm.callCaps.hourlyCap === -1) {
        vm.currentTargetGroup.schedule.hourlyCap = -1;
        vm.currentTargetGroup.schedule.callCapMatrix = null;
      } else {
        vm.currentTargetGroup.schedule.callCapMatrix = vm.currentTargetGroup.schedule.callCapMatrix || targetService.createMatrix(undefined);

        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            if (vm.currentTargetGroup.schedule.callCapMatrix[day][hour] == null) {
              vm.currentTargetGroup.schedule.callCapMatrix[day][hour] = -1;
            }
          }
        }
      }

      if (vm.callCaps.dailyCap === -1) {
        vm.currentTargetGroup.schedule.dailyCap = -1;
        vm.currentTargetGroup.schedule.dailyCapDayOfWeek = undefined;
      } else {
        vm.currentTargetGroup.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToStore(vm.currentTargetGroup.schedule.dailyCapDayOfWeek);
      }
    }

    function _resetConcurrencyCap() {
      if (vm.callCaps.concurrencyCap === -1) { vm.currentTargetGroup.schedule.concurrencyCap = -1; }
      if (!vm.setConcurrency) { vm.currentTargetGroup.schedule.callConcurrencyMatrix = null; }
    }

    function _resetHours() {
      if (!vm.setHours) { vm.currentTargetGroup.schedule.hoursOfOperation = null; }
    }

    function _updateCallCapsInTargetGroup(callCaps, schedule) {
      angular.forEach(callCaps, function (value, key) {
        if (value === -1) {
          delete schedule[key];
        }
      });
    }
    function matrixUpdated(newVal) {
      vm.currentTargetGroup.schedule = vm.currentTargetGroup.schedule || {};
      vm.currentTargetGroup.schedule.callCapMatrix = newVal;
    }

    function onWeekDayMatrixUpdated(newVal) {
      vm.currentTargetGroup.schedule = vm.currentTargetGroup.schedule || {};
      vm.currentTargetGroup.schedule.dailyCapDayOfWeek = newVal;
    }

    function onRefreshTargets() {
      vm.isRefreshingTargets = true;
      try {
        _loadTargets();
      } finally {
        $timeout(() => {
          vm.isRefreshingTargets = false;
        }, 600);
      }
    }

    function toggleSetHours() {
      if (vm.currentTargetGroup?.schedule?.hoursOfOperation && !vm.setHours) {
        vm.setHours = true;
      }
    }

    function onRefreshRingTreeTargets() {
      vm.isRefreshingRingTreeTargets = true;
      try {
        _loadRingTreeTargets();
      } finally {
        $timeout(() => {
          vm.isRefreshingRingTreeTargets = false;
        }, 600);
      }
    }
  }



})();
